import { filterElements, getValueFilters } from "PFApp/use_filtered_collection";
import usePaginatedArray from "PFApp/use_paginated_array";
import { LoadingDots } from "PFComponents/loading_dots";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Group from "./group";

const GroupByView = ({ groupByFilterKey, meta, type, isFetching }) => {
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const { search_id: searchId } = meta;

  const anyGroups = groups.length > 0;
  const filters = filterElements(meta.filters);
  const groupByFilter = filters.find(({ name }) => name === groupByFilterKey);

  const valueFilters = getValueFilters(meta.filters);
  const selectedOrder = meta.order?.value;

  useEffect(() => {
    setLoading(true);
    fetchPaginatedCollection(ApiRoute("/api/options/filters"), {
      search_id: searchId,
      name: groupByFilterKey,
      perPage: 100
    }).then(
      (response) => {
        setGroups(response.entries);
        setSelectedGroups([]);
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [groupByFilterKey, searchId]);

  const visibleGroups = selectedGroups.length > 0 ? selectedGroups : groups;

  const { page, totalPages, setPage, data } = usePaginatedArray(visibleGroups, { perPage: 3 });

  useEffect(() => {
    setPage(1);
  }, [selectedGroups]);

  const handleSelectGroup = (group) => {
    const newSelectedGroups = [...selectedGroups];
    const selectedGroupIndex = newSelectedGroups.findIndex(({ id }) => id === group.id);
    if (selectedGroupIndex !== -1) {
      newSelectedGroups.splice(selectedGroupIndex, 1);
    } else {
      newSelectedGroups.push(group);
    }
    setSelectedGroups(newSelectedGroups);
  };

  if (isFetching || loading) {
    return <LoadingDots circlesEnabled pageViewEnabled />;
  }

  return groupByFilter && anyGroups ? (
    <>
      {data.map((group) => (
        <Group
          key={group.id}
          group={group}
          filter={groupByFilter}
          valueFilters={valueFilters}
          selectedOrder={selectedOrder}
          type={type}
          groups={groups}
          selectedGroups={selectedGroups}
          onGroupSelected={handleSelectGroup}
        />
      ))}
      <div style={{ display: "flex" }}>
        <SimplePagination
          style={{ position: "sticky", left: "50%", transform: "translate(-50%, 0px)" }}
          currentPage={page}
          handleClick={(number) => setPage(number)}
          totalPages={totalPages}
        />
      </div>
    </>
  ) : (
    <Group filter={groupByFilter} valueFilters={valueFilters} selectedOrder={selectedOrder} type={type} />
  );
};

GroupByView.propTypes = {
  meta: PropTypes.shape({
    filters: PropTypes.object.isRequired,
    order: PropTypes.shape({
      value: PropTypes.object
    }),
    search_id: PropTypes.number.isRequired
  }).isRequired,
  groupByFilterKey: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["engagements", "roles"]).isRequired,
  isFetching: PropTypes.bool
};

export default GroupByView;
